<template>
  <div class="form-base">
    <v-row>
      <v-col cols="4">
        <v-text-field
          label="Фамилия"
          outlined
          v-model.trim="v.lastName.$model"
          :errorMessages="getValidationErrorText(v.lastName)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Имя"
          outlined
          v-model.trim="v.firstName.$model"
          :errorMessages="getValidationErrorText(v.firstName)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Отчество (при наличии)"
          outlined
          v-model.trim="v.patronymic.$model"
          :errorMessages="getValidationErrorText(v.patronymic)"
        />
      </v-col>

      <v-col cols="4">
        <DateFieldCustom
          label="Дата рождения"
          :value="v.birthDate.$model"
          @change="v.birthDate.$model = $event"
          :errorMessage="v.birthDate"
          :max="new Date().toISOString()"
        />
      </v-col>
    </v-row>

    <IdentityDocument :v="v.identityDocument" :documents="identityDocuments" />
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';
import { and, maxLength, required } from 'vuelidate/lib/validators';

import {
  DATE_FORMAT,
  DATE_FUTURE,
  DATE_PAST,
  getValidationErrorText,
  MAX_LENGTH,
  PERSON_NAME,
} from '@/utils/validate';
import IdentityDocument, {
  identityDocumentModel,
  identityDocumentValidation,
} from '@/components/services/elements/IdentityDocument';
import DateFieldCustom from '@/components/base/DateFieldCustom';
import { IdentityDocumentsRodModule } from '@/store/modules/identityDocumentsRod';

export const proxyPersonPersonModel = {
  lastName: '',
  firstName: '',
  patronymic: '',
  birthDate: '',
  identityDocument: cloneDeep(identityDocumentModel),
};

export const proxyPersonPersonValidation = {
  lastName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  firstName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  patronymic: {
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  birthDate: {
    required,
    DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
  },
  identityDocument: identityDocumentValidation,
};

export default {
  name: 'ProxyPersonPerson',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    DateFieldCustom,
    IdentityDocument,
  },
  data: () => ({
    getValidationErrorText,
  }),
  computed: {
    identityDocuments() {
      return IdentityDocumentsRodModule.list;
    },
  },
  async mounted() {
    if (
      !IdentityDocumentsRodModule.loading &&
      !IdentityDocumentsRodModule.loaded
    ) {
      await IdentityDocumentsRodModule.loadAll();
    }
  },
};
</script>
